import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
    name: 'ui',
    initialState: {
        screen: {},
        mts: false,
        activeChart: null,
        sidebarOpen: true,
    },
    reducers: {
        setScreen: (state, { payload }) => { state.screen = payload; },
        setMts: (state, { payload }) => { state.mts = payload; },
        setActiveChart: (state, { payload }) => { state.activeChart = payload; },
        setSidebarOpen: (state, { payload }) => { state.sidebarOpen = payload; },
        toggleSidebar: (state) => { state.sidebarOpen = !state.sidebarOpen; },
    },
});

export const {
    setScreen,
    setMts,
    setActiveChart,
    setSidebarOpen,
    toggleSidebar,
} = uiSlice.actions;

export default uiSlice.reducer;